export default __webpack_public_path__ + "static/media/Thug's Boots of Waning Dusk.fd8f4798.jpg";